import SORT_ORDERS from 'constants/sortOrders'

export const TABLE_PARAMS = {
    sort: {
        default: `orderNumber,${SORT_ORDERS.asc}`,
    },
    page: {
        default: 0,
        getValue: v => Number(v),
    },
    size: {
        default: 20,
        getValue: v => Number(v),
    },
    blockTypeId: {
        getValue: v => Number(v),
    },
}

export const MODALS = {
    CREATE_TEMPLATE: 'CREATE_TEMPLATE',
    EDIT_TEMPLATE: 'EDIT_TEMPLATE',
    REMOVE_TEMPLATE: 'REMOVE_TEMPLATE',
}
